import { render, staticRenderFns } from "./CookieNotice.vue?vue&type=template&id=43b38349&scoped=true&"
import script from "./CookieNotice.vue?vue&type=script&lang=ts&"
export * from "./CookieNotice.vue?vue&type=script&lang=ts&"
import style0 from "./CookieNotice.vue?vue&type=style&index=0&id=43b38349&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b38349",
  null
  
)

export default component.exports